var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3308_582)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4165 21.6149H17.5832C18.0144 21.6149 18.3644 21.2649 18.3644 20.8337C18.3644 20.4024 18.0144 20.0524 17.5832 20.0524H13.4165C12.9853 20.0524 12.6353 20.4024 12.6353 20.8337C12.6353 21.2649 12.9853 21.6149 13.4165 21.6149ZM26.1769 4.16699C26.1769 3.73522 25.8269 3.38574 25.3957 3.38574H5.604C5.17275 3.38574 4.82275 3.73522 4.82275 4.16699V18.2295C4.82275 18.6607 5.17275 19.0107 5.604 19.0107H25.3957C25.8269 19.0107 26.1769 18.6607 26.1769 18.2295V4.16699ZM24.6144 4.94824V17.4482H6.38525V4.94824H24.6144ZM13.2905 10.9373C11.667 11.7493 10.5519 13.4279 10.5519 15.3649C10.5519 15.7962 10.9019 16.1462 11.3332 16.1462C11.7644 16.1462 12.1144 15.7962 12.1144 15.3649C12.1144 13.4962 13.6316 11.9795 15.4998 11.9795C17.3681 11.9795 18.8853 13.4962 18.8853 15.3649C18.8853 15.7962 19.2353 16.1462 19.6665 16.1462C20.0978 16.1462 20.4478 15.7962 20.4478 15.3649C20.4478 13.4279 19.3327 11.7493 17.7092 10.9373C18.1186 10.4415 18.3644 9.80657 18.3644 9.11491C18.3644 7.53366 17.0811 6.25033 15.4998 6.25033C13.9186 6.25033 12.6353 7.53366 12.6353 9.11491C12.6353 9.80657 12.8811 10.4415 13.2905 10.9373ZM15.4998 7.81282C16.2186 7.81282 16.8019 8.39616 16.8019 9.11491C16.8019 9.83314 16.2186 10.417 15.4998 10.417C14.7811 10.417 14.1978 9.83314 14.1978 9.11491C14.1978 8.39616 14.7811 7.81282 15.4998 7.81282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3308_582",
    x: -1,
    y: 0,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3308_582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3308_582",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3f2efec4d6708b8dc6ea36cc3aec6173.svg";
export { ForwardRef as ReactComponent };